import React from 'react';
import PropTypes from 'prop-types';

import { SuiTextInput, SuiField } from '@splashthat/sui';
import { SplashSliderWrapper, SliderWrapper, InputWrapper } from './SplashSlider.styled';

export default class SplashSlider extends React.Component {
    static propTypes = {
        value: PropTypes.number.isRequired,
        minValue: PropTypes.number,
        maxValue: PropTypes.number,
        stepValue: PropTypes.number,
        onChange: PropTypes.func.isRequired,
    };

    static defaultProps = {
        minValue: 0,
        maxValue: 100,
        stepValue: 1,
    };

    onChangeOpacityValue = ({ target }) => {
        const { value } = target;

        if (value > this.props.maxValue) {
            return;
        }

        this.props.onChange(value);
    };

    render() {
        const { value, minValue, maxValue, stepValue } = this.props;

        return (
            <SplashSliderWrapper>
                <SliderWrapper>
                    <SuiField
                        fullWidth
                        formElement={
                            <input
                                min={minValue}
                                max={maxValue}
                                step={stepValue}
                                value={value}
                                type="range"
                                onChange={this.onChangeOpacityValue}
                            />
                        }
                    />
                </SliderWrapper>
                <InputWrapper>
                    <SuiTextInput
                        fullWidth
                        type="number"
                        min={minValue}
                        max={maxValue}
                        value={parseInt(value, 10)}
                        onChange={this.onChangeOpacityValue}
                    />
                </InputWrapper>
            </SplashSliderWrapper>
        );
    }
}
